var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Content/Lists") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C13.65675,2 15,3.37769231 15,5.07692308 C15,5.57307692 14.883,6.10692308 14.679,6.61538462 C14.5725,6.88230769 14.442,7.14153846 14.28975,7.38461538 C14.112,7.66846154 13.9065,7.93076923 13.67775,8.15384615 L13.67775,8.15384615 L15,8.15384615 C16.65675,8.15384615 18,9.53153846 18,11.2307692 L18,11.2307692 L18,20.4615385 C18,21.3115385 17.32875,22 16.5,22 L16.5,22 L7.5,22 C6.67125,22 6,21.3115385 6,20.4615385 L6,20.4615385 L6,11.2307692 C6,9.53153846 7.34325,8.15384615 9,8.15384615 L9,8.15384615 L10.32225,8.15384615 C10.0935,7.93076923 9.888,7.66846154 9.71025,7.38461538 C9.558,7.14153846 9.4275,6.88230769 9.321,6.61538462 C9.117,6.10692308 9,5.57307692 9,5.07692308 C9,3.37769231 10.34325,2 12,2 Z M4.30888544,5 C5.62884999,5 6.72933747,5.93177778 7,7.17466667 C5.61023709,7.97422222 4.66873477,9.46988889 4.65477509,11.1848889 C4.65477509,11.1848889 4.65399956,11.1856667 4.65322402,11.1856667 L4.65322402,11.1856667 L4.65322402,19 L1.55107467,19 C0.694105916,19 0,18.3038889 0,17.4444444 L0,17.4444444 L0,13.5555556 C0,11.9681111 1.18967427,10.6738889 2.72058498,10.4833333 C2.01407046,9.78177778 1.55107467,8.69911111 1.55107467,7.76577778 C1.55107467,6.23822222 2.78573011,5 4.30888544,5 Z M19.6914127,5 C21.2139612,5 22.4487535,6.23822222 22.4487535,7.76577778 C22.4487535,8.69988889 21.9857064,9.78177778 21.2791136,10.4833333 C22.8101939,10.6738889 24,11.9688889 24,13.5555556 L24,13.5555556 L24,17.4444444 C24,18.3038889 23.3058172,19 22.4487535,19 L22.4487535,19 L19.3462604,19 L19.3462604,11.1856667 C19.3307479,9.46988889 18.3891413,7.975 17,7.17544444 C17.2699169,5.93255556 18.3705263,5 19.6914127,5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "----Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-875.000000, -2553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/_Stickersheet",
    transform: "translate(412.500000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/HubSpotobjects/Lists",
    transform: "translate(463.000000, 2167.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icons/Content/Lists",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/Customers.e3263f265c529570dfa11b2abc1878cf.svg";
export { ForwardRef as ReactComponent };